import { Box, Stack, Typography } from "@mui/material"
import NumberFunctions from "../../../../../core/functions/NumberFunctions"
import { red } from "@mui/material/colors"
import { QuantityPicker } from "../../../../Inputs/QuantityPicker"
import { useFormContext, useWatch } from "react-hook-form"
import { TSale } from "../../../../../core/types/Sale"
import CheckoutFunctions from "../../../../../core/functions/CheckoutFunctions"
import { useCheckoutContext } from "../../../../../core/hooks/useCheckoutContext"

interface DetailProductItem8Props {
  productImageUrl?: string | null
  productName?: string
  productDescription?: string
  value?: number | null
}

const DetailProductItem8 = ({
  productImageUrl,
  productName,
  productDescription,
  value,
}: DetailProductItem8Props) => {
  const { productPrice, displayCurrency } = useCheckoutContext()
  const { control, setValue } = useFormContext<TSale>()

  const quantityValue = useWatch({ control, name: "quantity", defaultValue: 1 })
  const totalPrice = value ? value * quantityValue : 0

  return (
    <Stack
      direction="row"
      spacing={2}
      alignContent="center"
      alignItems="center"
      width="100%"
      sx={{ px: 1, py: 0.5 }}
    >
      <Box sx={{ height: 120, width: 120 }}>
        {productImageUrl && productImageUrl !== "" && (
          <img
            src={productImageUrl}
            alt={productName}
            style={{
              height: 120,
              width: 120,
              objectFit: "cover",
              borderRadius: "20px",
            }}
          />
        )}
      </Box>
      <Stack
        direction="row"
        spacing={2}
        alignContent="center"
        justifyContent="space-between"
        width="100%"
      >
        <Box gap="16px" width="100%">
          <Typography
            color="#343948"
            fontWeight={600}
            fontSize={{ xs: "16px", sm: "18px" }}
            lineHeight={{ xs: "20px", sm: "22px" }}
          >
            {productName}
          </Typography>
          <Typography
            color="#343948"
            fontWeight={400}
            fontSize={{ xs: "14px", sm: "16px" }}
            lineHeight={{ xs: "18px", sm: "20px" }}
          >
            {productDescription}
          </Typography>
          <Stack
            direction="row"
            spacing={2}
            alignContent="center"
            justifyContent="space-between"
            width="100%"
            sx={{ pt: 1 }}
          >
            <Stack justifyContent="center">
              <Typography
                fontWeight={700}
                sx={{
                  fontSize: "20px",
                  lineHeight: "24px",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                {NumberFunctions.formatMoneyCurrency(totalPrice, displayCurrency)}
                <Typography
                  fontWeight={400}
                  color={red[500]}
                  sx={{
                    fontSize: "14px",
                    lineHeight: "18px",
                    textDecoration: "line-through",
                    pl: 1,
                  }}
                >
                  {NumberFunctions.formatMoneyDefault(59)}
                </Typography>
              </Typography>
            </Stack>
            <Stack
              direction="column"
              spacing={1}
              alignContent="end"
              alignItems="end"
            >
              {CheckoutFunctions.isAllowsChooseQuantity(productPrice) && (
                <Box>
                  <QuantityPicker
                    value={quantityValue}
                    onChange={(next) => setValue("quantity", next)}
                    min={1}
                    size="md"
                  />
                </Box>
              )}
            </Stack>
          </Stack>
        </Box>
      </Stack>
    </Stack>
  )
}

export default DetailProductItem8
